import React from "react";
import { motion } from "framer-motion";
import { Dumbbell, Apple, Users, LineChart, Sparkles } from "lucide-react";
import { PILLARS } from "@/data/content";

const ICONS = { Dumbbell, Apple, Users, LineChart, Sparkles };

export const WhyAlphaPulse = () => {
  return (
    <section data-testid="why-section" className="relative py-24 md:py-32 bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-vitality">Why AlphaPulse</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight mt-4 leading-tight">
            One App. Every Tool You Need To Win.
          </h2>
          <p className="text-white/60 mt-4 text-lg">
            Fitness, nutrition, accountability and community brought together into one seamless experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <motion.div
                key={p.title}
                data-testid={`pillar-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="glass rounded-2xl p-7 hover:border-vitality/40 hover:-translate-y-1 transition-all duration-300 group"
              >
                <div className="w-12 h-12 rounded-xl bg-vitality/10 flex items-center justify-center mb-5 group-hover:bg-vitality/20 transition-colors">
                  <Icon className="w-6 h-6 text-vitality" strokeWidth={2} />
                </div>
                <h3 className="font-heading text-2xl font-bold uppercase tracking-tight">{p.title}</h3>
                <p className="text-white/60 mt-3 leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
